const getApiBaseUrl = require('../config/apiBaseUrl').default;

function getBaseUrl() {
  return getApiBaseUrl() + '/api/v1';
}

function getTraderApiBase() {
  return getApiBaseUrl() + '/trader_app/api/v1';
}

// Simple path exports (base API) – getters so host is resolved at use time
const BASE_URL_PATHS = [
  ['SIGNIN_URL', '/company/login/'],
  ['GET_CURRENT_USER_URL', '/current_profile/'],
  ['GET_OUTGROWER_URL', '/outgrowerscheme/'],
  ['GET_OUTGROWER_SCHEME_URL', '/outgrowerscheme/'],
  ['GET_FARMERS_URL', '/farmer/'],
  ['GET_FARM_URL', '/farm/'],
  ['GET_USERS_URL', '/userobject/'],
  ['GET_AGENTS_URL', '/agent/'],
  ['GET_COMPANIES_URL', '/company/'],
  ['REGISTER_ADMIN_URL', '/register/'],
  ['REGISTER_COMPANY_URL', '/company/'],
  ['GET_SCHEME_APPLICATION_URL', '/get_scheme_applications/'],
  ['GET_SCHEME_APPS_BY_STATUS_URL', '/get_scheme_apps_by_status/'],
  ['GET_SCHEMES_URL', '/outgrowerscheme/'],
  ['COMPANY_SCHEME_URL', '/get_schemes_by_company_id/'],
  ['COMPANY_AGENT_URL', '/get_agents_by_company_id/'],
  ['COMPANY_AGRONOMIST_URL', '/agronomist_by_company_id/'],
  ['COMPANY_AGRODEALER_URL', '/agrodealer_by_company_id/'],
  ['GET_INPUT_DELIVERY_URL', '/input_delivery/'],
  ['GET_FARM_INSPECTIONS_URL', '/farm-inspections/'],
  ['GET_ACTIVITY_LOG_URL', '/activity/'],
  ['GET_FARMER_COMPLAINTS_URL', '/farmer_complaints/'],
  ['GET_SUPPORT_EMAILS_URL', '/support_emails/'],
  ['GET_FARMS_BY_FARMER_URL', '/get_farm_by_farmer_id/'],
  ['GET_SCHEME_APPLICATIONS_BY_FARMER_URL', '/get_scheme_applications_by_farmer_id/'],
  ['GET_INPUT_DELIVERY_BY_FARMER_URL', '/input_delivery_by_farmer/'],
  ['GET_HARVEST_BY_FARMER_URL', '/farmer_harvest_by_farmer/'],
  ['GET_FARMER_INPUT_HISTORY_URL', '/farmer-input-history/'],
  ['GET_PROVINCES_URL', '/provinces/'],
];

BASE_URL_PATHS.forEach(([name, path]) => {
  Object.defineProperty(exports, name, {
    get: () => getBaseUrl() + path,
    enumerable: true,
  });
});

// Function exports (base URL)
exports.SEARCH_COMPANY_URL = (query) => getBaseUrl() + '/search_company/?q=' + encodeURIComponent(query);
exports.COMPANY_DATA_URL = (id) => getBaseUrl() + '/company/' + id + '/';
exports.COMPANY_VERIFY_URL = (pacra_id) => getBaseUrl() + '/verify_company/' + encodeURIComponent(pacra_id) + '/';
exports.USER_DATA_URL = (id) => getBaseUrl() + '/userobject/' + id + '/';
exports.GET_USERS_ROLE_URL = (role) => getBaseUrl() + '/get_user/?role=' + encodeURIComponent(role);
exports.SEARCH_FARMER_URL = (query) => getBaseUrl() + '/search_users/?q=' + encodeURIComponent(query);
exports.COMPANY_ID_URL = (id) => getBaseUrl() + '/company/' + id + '/';
exports.FARM_ID_URL = (id) => getBaseUrl() + '/farm/' + id + '/';

const companyUsersBase = (page, pageSize, role) => {
  const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
  if (role && role !== 'all') params.set('role', role);
  return getBaseUrl() + '/search_company_users/?' + params.toString();
};
exports.GET_COMPANY_USERS_URL = (page = 1, pageSize = 10, role = '') =>
  companyUsersBase(page, pageSize, role);
exports.SEARCH_COMPANY_USERS_URL = (q, page = 1, pageSize = 10, role = '') => {
  const params = new URLSearchParams({ q, page: String(page), page_size: String(pageSize) });
  if (role && role !== 'all') params.set('role', role);
  return getBaseUrl() + '/search_company_users/?' + params.toString();
};

exports.GET_SCHEME_APPLICATIONS_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10, status = '') => {
  const params = new URLSearchParams({ scheme__company__pacra_id: pacraId, page: String(page), page_size: String(pageSize) });
  if (status && status !== 'all') params.set('application_status', status);
  return getBaseUrl() + '/get_scheme_applications/?' + params.toString();
};
exports.SCHEME_APPLICATION_ID_URL = (id) => getBaseUrl() + '/get_scheme_applications/' + id + '/';
exports.GET_SCHEMES_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10) =>
  getBaseUrl() + '/get_schemes_by_company_id/?pacra_id=' + encodeURIComponent(pacraId) + '&page=' + page + '&page_size=' + pageSize;
exports.SCHEME_ID_URL = (id) => getBaseUrl() + '/outgrowerscheme/' + id + '/';
exports.GET_SCHEME_APPLICATIONS_BY_SCHEME_URL = (schemeId, page = 1, pageSize = 100) => {
  const params = new URLSearchParams({ scheme: schemeId, page: String(page), page_size: String(pageSize) });
  return getBaseUrl() + '/get_scheme_applications/?' + params.toString();
};
exports.GET_SCHEME_MEMBERS_URL = (schemeId) => getBaseUrl() + '/scheme_members/?scheme_id=' + encodeURIComponent(schemeId);
exports.GET_AGENTS_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10) =>
  getBaseUrl() + '/get_agents_by_company_id/?pacra_id=' + encodeURIComponent(pacraId) + '&page=' + page + '&page_size=' + pageSize;
exports.SEARCH_SCHEME_URL = (pacraId, query) => getBaseUrl() + '/search/schemes/?q=' + encodeURIComponent(query) + '&pacra_id=' + encodeURIComponent(pacraId);
exports.SEARCH_AGENT_URL = (id, query) => getBaseUrl() + '/search/agents_in_company/?q=' + encodeURIComponent(query) + '&pacra_id=' + id;
exports.SEARCH_AGRODEALER_URL = (query) => getBaseUrl() + '/search/agrodealers/?q=' + encodeURIComponent(query);
exports.GET_INPUT_DELIVERIES_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ scheme__company__pacra_id: pacraId, page: String(page), page_size: String(pageSize) });
  return getBaseUrl() + '/input_delivery/?' + params.toString();
};
exports.INPUT_DELIVERY_ID_URL = (id) => getBaseUrl() + '/input_delivery/' + id + '/';
exports.GET_ACTIVITY_LOG_BY_ACTOR_URL = (actorId) => getBaseUrl() + '/activity/?actor=' + encodeURIComponent(actorId);
exports.FARM_INSPECTION_ID_URL = (id) => getBaseUrl() + '/farm-inspections/' + id + '/';
exports.GET_FARM_INSPECTION_VISITS_URL = () => getBaseUrl() + '/farm-inspection-visits/';
exports.GET_FARMER_INVENTORY_URL = (farmerId) => getBaseUrl() + '/get_farmer_input_inventory/' + farmerId + '/';

// Trader API – simple path getters
const TRADER_URL_PATHS = [
  ['GET_PRESEASON_CONTRACTS_URL', '/contracts/preseason/'],
  ['GET_PRESEASON_APPLICATIONS_URL', '/contracts/applications/'],
  ['GET_FINAL_CONTRACTS_URL', '/contracts/final/'],
  ['GET_STANDARD_CONTRACTS_URL', '/standard_contracts/'],
  ['GET_TRADE_OFFERS_URL', '/trade_offers/'],
  ['GET_SELL_REQUESTS_URL', '/sell_requests/'],
  ['GET_PRODUCTS_URL', '/products/'],
];

TRADER_URL_PATHS.forEach(([name, path]) => {
  Object.defineProperty(exports, name, {
    get: () => getTraderApiBase() + path,
    enumerable: true,
  });
});

// Trader API – function exports
exports.GET_PRESEASON_CONTRACTS_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ company_pacra_id: pacraId, page: String(page), page_size: String(pageSize) });
  return getTraderApiBase() + '/contracts/preseason/?' + params.toString();
};
exports.PRESEASON_CONTRACT_ID_URL = (id) => getTraderApiBase() + '/contracts/preseason/' + id + '/';
exports.PRESEASON_CONTRACT_PRICE_HISTORY_URL = (id) =>
  getTraderApiBase() + '/contracts/preseason/' + encodeURIComponent(id) + '/price-history/';
exports.PRESEASON_CONTRACT_QUANTITY_HISTORY_URL = (id) =>
  getTraderApiBase() + '/contracts/preseason/' + encodeURIComponent(id) + '/quantity-history/';
exports.GET_TRADE_OFFERS_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ aggregator: pacraId, page: String(page), page_size: String(pageSize) });
  return getTraderApiBase() + '/trade_offers/?' + params.toString();
};
exports.GET_SELL_REQUESTS_BY_COMPANY_URL = (pacraId, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ trade_offer__aggregator: pacraId, page: String(page), page_size: String(pageSize) });
  return getTraderApiBase() + '/sell_requests/?' + params.toString();
};
exports.TRADE_OFFER_ID_URL = (id) => getTraderApiBase() + '/trade_offers/' + id + '/';
exports.SELL_REQUEST_ID_URL = (id) => getTraderApiBase() + '/sell_requests/' + id + '/';
exports.PRODUCT_ID_URL = (id) => getTraderApiBase() + '/products/' + id + '/';
